export default __webpack_public_path__ + "static/media/mPants_1_p2.1aaa5a12.jpeg";